import templateUrl from './process-change-history.component.html';
import { ChangeHistoryVM } from './employment-processing-models';
import { EventEmitter } from '../../common/components/event-emitter';

export const ProcessChangeHistoryComponent = {
    templateUrl,
    controller: class ProcessChangeHistoryComponent {
        fileName: string;
        changes: ChangeHistoryVM[];
        handleCancel: EventEmitter<any>;
        handleFinish: EventEmitter<any>;
        pageNumber = 1;
        pageSize = 10;

        $onInit() {
            console.log(this.changes);
        }

        selectionCount() {
            return this.changes.reduce(function (count, number) {
                return count + (number.isSelected ? 1 : 0);
            }, 0);
        }
    },
    controllerAs: "vm",
    bindings: {
        fileName: "<",
        changes: "<",
        handleCancel: "&",
        handleFinish: "&"
    }
};
